import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useAssetCollectionItems } from 'marketplace-ui-assets-core/hooks/useAssetCollectionItems';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import AssetStorefrontContainer from '../../storefront/containers/AssetStorefrontContainer';
import NotFoundError from '../../components/error/NotFoundError';
import { getIsInApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeCollectionContainer() {
  const {
    collection: slug
  } = useParams();
  const isInApp = useSelector(getIsInApp);
  const appContext = isInApp ? 'app' : 'public';
  const {
    getCollectionBySlug,
    requestState: collectionsRequestState
  } = usePublishedCollections({
    appContext,
    offeringType: 'THEME'
  });
  const collection = getCollectionBySlug(slug);
  const {
    fetchThemeCollectionItemIds
  } = useAssetCollectionItems({
    appContext,
    collectionId: collection ? collection.id : undefined
  });
  if (!isFulfilled(collectionsRequestState)) {
    return null;
  }
  if (!(collection && collection.publishedListing)) {
    return /*#__PURE__*/_jsx(NotFoundError, {});
  }
  return /*#__PURE__*/_jsx(AssetStorefrontContainer, {
    collectionId: collection.id,
    title: collection.publishedListing.title,
    description: /*#__PURE__*/_jsx(SanitizedText, {
      body: collection.publishedListing.description,
      WrapperComponent: "span"
    }),
    onFetchCollectionOfferingIds: fetchThemeCollectionItemIds
  });
}